import URL from "./parameters.js";
import axios from "axios";

const BASE_URL = URL.conference

export const getAllItems = async () => {
  const res = await axios.get(`${BASE_URL}`);
  return res.data;
};

export const deleteItem = async (element) => {
  const id = element.id;
  const res = await axios.delete(`${BASE_URL}${id}`);
  return res.data;
};

export const addItem = async (element) => {
  const res = await axios.post(`${BASE_URL}`, element);
  return res.data;
}

export const updateItem = async (element) => {
  const id = element.id;
  const res = await axios.patch(`${BASE_URL}${id}`, element);
  return res.data;
}


export const resetDB = async (INITIAL_TWEETS) => {
  await fetch(`${BASE_URL}/api/delete/all`, {
    method: "DELETE",
  });
  await fetch(`${BASE_URL}/api/insert-batch`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(INITIAL_TWEETS),
  });
};
